<template>
  <div class="admin-list">
    <div class="filter-bar">
      <input
        v-model="filters.keyword"
        class="filter-input"
        placeholder="账号 / 姓名 / 手机号"
        @keyup.enter="loadAdmins"
      />
      <select v-model="filters.status" class="filter-select">
        <option value="">全部状态</option>
        <option value="1">启用</option>
        <option value="0">禁用</option>
      </select>
      <button class="btn btn-primary" @click="loadAdmins">查询</button>
      <button class="btn btn-default" @click="resetFilters">重置</button>
      <router-link to="/admin-accounts/create" class="btn btn-success">新增管理员</router-link>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>登录账号</th>
          <th>姓名</th>
          <th>手机号</th>
          <th>角色</th>
          <th>绑定用户ID</th>
          <th>状态</th>
          <th>登录时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.real_name || '-' }}</td>
          <td>{{ item.phone || '-' }}</td>
          <td>{{ item.role ? item.role.role_name : '-' }}</td>
          <td>{{ item.user_id || '-' }}</td>
          <td>
            <span :class="['status-tag', item.status === 1 ? 'enabled' : 'disabled']">
              {{ item.status === 1 ? '启用' : '禁用' }}
            </span>
          </td>
          <td>{{ formatDateTime(item.login_time) }}</td>
          <td>
            <button class="action-btn view" @click="$router.push(`/admin-accounts/edit/${item.id}`)">编辑</button>
            <button class="action-btn disable" @click="deleteAdmin(item)">删除</button>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="9" class="empty">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="total > 0">
      <button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button class="page-btn" :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">下一页</button>
    </div>
  </div>
</template>

<script>
import { getAdmins, deleteAdmin } from '@/api/system'

export default {
  name: 'AdminList',
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      perPage: 15,
      filters: {
        keyword: '',
        status: ''
      },
      loading: false
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage))
    }
  },
  mounted() {
    this.loadAdmins()
  },
  methods: {
    async loadAdmins() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
          keyword: this.filters.keyword || undefined,
          status: this.filters.status !== '' ? this.filters.status : undefined
        }
        const res = await getAdmins(params)
        const data = res || {}
        this.list = data.data || data.list || []
        this.total = data.total || this.list.length
      } catch (e) {
        this.$message && this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    formatDateTime(value) {
      if (!value) return '-'
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    resetFilters() {
      this.filters = { keyword: '', status: '' }
      this.currentPage = 1
      this.loadAdmins()
    },
    changePage(page) {
      this.currentPage = page
      this.loadAdmins()
    },
    async deleteAdmin(item) {
      if (!confirm(`确认删除管理员「${item.real_name || item.username}」？`)) return
      try {
        await deleteAdmin(item.id)
        this.$message && this.$message.success('删除成功')
        this.loadAdmins()
      } catch (e) {
        this.$message && this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;
}
.filter-input,
.filter-select {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.data-table th,
.data-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
}
.data-table th {
  background: #fafafa;
  font-weight: 600;
}
.data-table tr:hover td {
  background: #f9faff;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
}
.btn-primary {
  background: #667eea;
  color: #fff;
}
.btn-default {
  background: #eee;
  color: #333;
}
.btn-success {
  background: #2ecc71;
  color: #fff;
}
.status-tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
}
.status-tag.enabled {
  background: #e8f8f0;
  color: #2ecc71;
}
.status-tag.disabled {
  background: #fdecea;
  color: #e74c3c;
}
.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}
.action-btn.view {
  background: #3498db;
  color: #fff;
}
.action-btn.disable {
  background: #e74c3c;
  color: #fff;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 16px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 14px;
  color: #666;
}
</style>
